import React from "react";

const Amanities = ({ formData }) => {
  return (
    <div>
        <div className="clp-header">
            <h4 className='ws-title'>Property Amenities</h4>
            <p className="ws-desc">Please select all the amenities available at your property</p>
        </div>
      <p>Name: {formData.name}</p>
      <p>Email: {formData.email}</p>
    </div>
  );
};

export default Amanities;
